/// <reference path="bugsnag.d.ts" />

import { ErrorHandler } from '@angular/core';

export class BugsnagErrorHandler implements ErrorHandler {
  handleError(error: any) {
    Bugsnag.notifyException(error);
    console.error(error);
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/bugsnag/error-handler.ts